<template>
  <div id="closeOrder">
    <el-row>
      <el-col :span="12" :offset="0.5">
        <el-row>
          <el-form :inline="true" @submit.native.prevent>
            <el-form-item>
              <span>请选择订单号:</span>
            </el-form-item>
            <el-form-item>
              <el-select v-model="orderId" placeholder="请选择">
                <el-option v-for="item in orders" :key="item.id" :label="item.id" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <span v-if="orders.length==0">无可关闭订单</span>
            </el-form-item>
          </el-form>
        </el-row>
        <el-row v-if="orderId">
          <el-tabs
            type="border-card"
            tab-position="top"
            :stretch="true"
            style="margin-bottom: 30px;"
            v-model="cardName"
          >
            <el-tab-pane label="订单信息" name="orderInfo">
              <OrderLabel
                :order="order"
                :disabled="true"
                :label="label"
                :files="files"
                :users="users"
              ></OrderLabel>
            </el-tab-pane>
            <el-tab-pane label="刀模信息">
              <table border="1" cellspacing="0" style="width: 100%; margin:10px 0 30px 0">
                <tr>
                  <th>刀具名字</th>
                  <th>列x行</th>
                  <th>左右间距(mm)</th>
                  <th>上下间距(mm)</th>
                </tr>
                <tr v-for="item in cutter">
                  <td>{{item.name}}</td>
                  <td>{{item.row}}x{{item.line}}</td>
                  <td>{{item.vSpacing}}</td>
                  <td>{{item.hSpacing}}</td>
                </tr>
              </table>
            </el-tab-pane>
            <el-tab-pane label="材料信息">
              <el-row>
                <span>材料名称: {{label.material}}</span>
              </el-row>
              <el-row>
                <table border="1" cellspacing="0" style="width: 100%; margin:10px 0 30px 0">
                  <tr>
                    <th>宽度(mm)</th>
                    <th>选取米数(m)</th>
                    <th>剩余米数(m)</th>
                    <th>使用米数(m)</th>
                  </tr>
                  <tr v-for="item in material">
                    <td>{{item.wide}}</td>
                    <td>{{item.chooseM}}</td>
                    <td>{{item.remainM}}</td>
                    <td>{{item.chooseM-item.remainM}}</td>
                  </tr>
                </table>
              </el-row>
            </el-tab-pane>
          </el-tabs>
        </el-row>
      </el-col>
      <el-col :span="10" :offset="1" v-if="orders.length!=0&&orderId!=''">
        <el-form
          :model="closeFrom"
          label-width="160px"
          style="margin-top:50px"
          @submit.native.prevent
        >
          <el-form-item>
            <h3>标签类型: {{label.lbLength}} x {{label.lbWidth}} x {{order.quantity}}</h3>
          </el-form-item>
          <el-form-item label="产量(卷)" required>
            <el-input-number v-model="closeFrom.realGoods" :precision="2" :step="1" :min="0"></el-input-number>
          </el-form-item>
          <el-form-item label="多生产(卷)" required>
            <el-input-number v-model="closeFrom.moreGoods" :precision="2" :step="1" :min="0"></el-input-number>
          </el-form-item>
          <el-form-item size="large">
            <el-button :loading="startloading" @click="onSubmit" type="primary">关闭订单</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import OrderLabel from "@/components/production/OrderLabel";
import Vue from "vue";
export default {
  components: {
    OrderLabel
  },
  data: function() {
    return {
      orders: [],
      //终端发出
      postApi: {
        crud: "",
        info: {}
      },
      //终端接收
      message: {
        result: {
          infos: []
        }
      },
      orderId: "订单信息",

      //订单信息
      order: {},

      //标签信息
      label: {},

      //相关人员信息
      users: {},

      //附件信息
      files: {},

      //材料信息
      material: [],

      //刀具信息
      cutter: [],

      closeFrom: {
        realGoods: 0,
        moreGoods: 0
      },
      cardName: "orderInfo",
      startloading: false
    };
  },
  created: function() {
    this.init();
  },
  watch: {
    orderId: async function(val) {
      if (val != "") {
        this.postApi.crud = "ri";
        this.postApi.info = {
          key: val
        };
        this.message = await this.$doPost(
          "/api/production/order",
          this.postApi
        );
        if (this.message.msgCode == 0) {
          this.order = this.message.result.infos.order;
          // console.log(this.message.result.infos)
          // this.order.id = this.order.id.substring(0, 5);
          this.label = this.message.result.infos.label;
          this.files = this.message.result.infos.files;
          this.users = this.message.result.infos.users;
          this.cardName = "orderInfo";
        } else {
          this.$message.error(this.message.msg);
        }

        this.message = await this.$doPost(
          "/api/production/close",
          this.postApi
        );
        if (this.message.msgCode == 0) {
          this.cutter = this.message.result.infos.cutter;
          // console.log(this.message.result.infos);
          this.material = this.message.result.infos.material;
        } else {
          this.$message.error(this.message.msg);
        }
        this.closeFrom = {
          realGoods: 0,
          moreGoods: 0
        };
      }
    }
  },
  methods: {
    init: async function() {
      this.orderId = "";
      this.postApi.crud = "r";
      this.postApi.info = {
        key: {
          id: "",
          superSearch: true,
          orderStatus: 3,
          searchTime: null
        }
      };
      this.message = await this.$doPost("/api/production/order", this.postApi);
      if (this.message.msgCode == 0) {
        this.orders = this.message.result.infos;
      } else {
        this.$message.error(this.message.msg);
        this.orders = [];
      }
    },
    onSubmit: function() {
      if (this.closeFrom.realGoods != 0) {
        this.$confirm("是否关闭订单:" + this.orderId + "?", "提示", {})
          .then(async () => {
            this.postApi.crud = "u";
            this.postApi.info = {
              key: {
                orderId: this.orderId
              },
              realGoods: this.closeFrom.realGoods,
              moreGoods: this.closeFrom.moreGoods
            };
            this.startloading = true;
            this.message = await this.$doPost(
              "/api/production/close",
              this.postApi
            );
            if (this.message.msgCode == 0) {
              this.init();
            } else {
              this.$message.error(this.message.msg);
            }
            this.startloading = false;
          })
          .catch(() => {}); //一定别忘了这个;
      } else {
        this.$message.error("产量不能为0");
      }
    }
  },
  props: {
    roles: Array
  }
};
</script>
<style>
/* td{
  margin-bottom: 
} */
</style>



// WEBPACK FOOTER //
// src/components/production/CloseOrder.vue